<template>
	<div style="height: 100%; width:100%;">
		<div style="overflow: scroll; height: 100%; width:100%; color:white;">
			<el-row style="height:30px; padding:10px;">
				<el-col>
					<b>运行状况（事件）</b>
          		</el-col>
			</el-row>
			<el-row style="height:30px; padding:10px;">
				<el-col v-for="event in events">
					<b>{{event.description}}</b>
          		</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
	export default {
		components: {
		},
		props: ['events'],
		data() {
			return {
				eventCount:0,
			}
		},
		created() {},
		mounted() {
		},
		destroyed() {
		},
		computed: {
		},
		watch: {
		},
		methods: {
			formatEvent(event){
				if(event == '123'){
					return '告警事件';
				}else{
					return event;
				}
			},
			formatTime(time){
				return time;
			}
		}
	}
</script>